(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-wheel.js');
"use strict";


const _svs$tickets$play$uti = svs.tickets.play.utils.animations.wheel,
  intro = _svs$tickets$play$uti.intro,
  outro = _svs$tickets$play$uti.outro,
  select = _svs$tickets$play$uti.select,
  deSelect = _svs$tickets$play$uti.deSelect;
const TicketSkinImage = svs.tickets.play.components.TicketSkinImage;
setGlobal('svs.tickets.play.components.TicketSkinWheel', React.memo(_ref => {
  let _ref$appTimeline = _ref.appTimeline,
    appTimeline = _ref$appTimeline === void 0 ? gsap.timeline() : _ref$appTimeline,
    hasFocus = _ref.hasFocus,
    number = _ref.number,
    handleGamePay = _ref.handleGamePay,
    onHandleNumberChanged = _ref.onHandleNumberChanged,
    chosen = _ref.chosen,
    gamePayed = _ref.gamePayed,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation,
    image = _ref.image;
  const _React = React,
    useRef = _React.useRef,
    useEffect = _React.useEffect,
    useCallback = _React.useCallback;
  const ticketSkinRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const unmount = (intro[animation] || intro.default)(ticketSkinRef, appTimeline, number, chosen);
    return () => {
      unmount && unmount();
    };
  }, []);
  useEffect(() => {
    if (appTimeline.time() >= (appTimeline.labels.gameReady + 1 || 0) || appTimeline.progress() === 1) {
      if (chosen) {
        (select[animation] || select.default)(ticketSkinRef);
      } else {
        (deSelect[animation] || deSelect.default)(ticketSkinRef);
      }
    }
  }, [chosen]);
  useEffect(() => {
    if (gamePayed && chosen) {
      (outro[animation] || outro.default)(ticketSkinRef);
    }
  }, [gamePayed]);
  const onClick = useCallback(() => {
    if (!gamePayed && chosen) {
      handleGamePay && handleGamePay();
    } else {
      onHandleNumberChanged(number);
    }
  }, [gamePayed, chosen, handleGamePay, onHandleNumberChanged, number]);
  return React.createElement("div", {
    className: "ticket-skin-wrapper relative",
    "data-ticket-number": number,
    onClick: onClick,
    ref: ticketSkinRef,
    style: {
      transform: 'scale(0)'
    }
  }, React.createElement("div", {
    className: "ticket-number absolute"
  }, number), React.createElement("div", {
    className: "".concat(hasFocus ? 'ticket-skin-focus' : ''),
    ref: imgRef
  }, React.createElement(TicketSkinImage, {
    image: image,
    number: number
  })));
}));

 })(window);